import preparedReducer from './reducer';
import {
  requestBINotebookNotesByDateAndTag,
  requestBINotebookNotesByDate,
  requestBINotebookNotesByTag,
} from './actions';

export const reducer = preparedReducer;

export const SLICE_NAME = 'biNotebookNotes';

export const selectors = (state) => state[SLICE_NAME];

export const actions = {
  requestBINotebookNotesByTag,
  requestBINotebookNotesByDateAndTag,
  requestBINotebookNotesByDate,
};
